import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@sola/ark-core/atoms/skeleton/skeleton.tsx';
export const SponsorshipsSkeleton = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="component flex flex-col gap-comfy-xl max-w-md"><div className="max-w-xs"><Skeleton height={80} /></div><Skeleton height={400} /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};